export default __webpack_public_path__ + "static/sensor-overview-clip-19bc4d5d74c2c15e53958ce97073a4d4.mp4";